import { type ReactNode } from 'react'
import cn from 'classnames'
import Experiment from '@mc/experiments-react'
import { withI18nContext } from '@mc/i18n'
import { PricingText } from 'components/PricingText'
import type { StickyConfig } from 'components/Sticky/useSticky'
import { EXPERIMENT_FLAG } from '../constants'
import { useTrackPen7570Experiment } from '../hooks/useTrackPen7570Experiment'
import { EXPERIMENT_I18N_NAMESPACE, i18nInstance } from '../i18n'
import styles from './StickyPricingTextWrapper.module.scss'

interface StickyPricingTextWrapperProps {
  control: ReactNode
  stickyConfig?: StickyConfig
}

const VariantPricingText = withI18nContext(i18nInstance)(() => (
  <PricingText
    isStickyFooter
    defaultCopyI18nOverride={{
      i18nKey: 'stickyFooter.pricing',
      ns: EXPERIMENT_I18N_NAMESPACE,
    }}
  >
    <span className={cn('mc-text--bold', styles.topLine)} />
    <span className='d-block mc-opacity--muted' />
  </PricingText>
))

export const StickyPricingTextWrapper = ({
  control,
  stickyConfig,
}: StickyPricingTextWrapperProps) => {
  useTrackPen7570Experiment(stickyConfig)

  return (
    <Experiment
      name={EXPERIMENT_FLAG}
      track={false}
      control={() => control}
      variant_1={() => <VariantPricingText />}
    />
  )
}
